import { OrdersState } from "../state/ordersState";
import {
    RECEIVE_ORDERS,
    FETCH_ERROR,
    IS_LOADING,
    RECEIVE_STATUSES,
    UPDATE_FILTERS,
    CLEAR_FILTERS,
    RECEIVE_DOCUMENTS,
    RECEIVE_META_DATA,
    UPDATE_SELECTED_ORDERS,
    UPDATE_PAYMENT_INFO,
    RECEIVE_CURRENCY_EXCHANGE_RATES
} from "../actions/ordersActions";
import { RECEIVE_CURRENT_USER, RECEIVE_USER_LOGOUT } from "../actions/sessionActions";
import { User } from "../../models/User";
import { IDocumentReference } from "../../interfaces/IDocumentReference";
import { IPaymentInfo } from "../../interfaces/IPaymentInfo";

const paymentArray: IPaymentInfo = {
    firstName: "Test",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    country: "USA",
    amount: "",
    accttype: "",
    cardNumber: "",
    expDate: "",
    expMonth: "",
    expYear: "",
    cvv: "",
    mytoken: "",
    orders: [],
    paymentAmount: "0"
}
const initState: OrdersState = {
    loading: false,
    ordersList: [],
    fetchError: false,
    selectedOrderList: [],
    filters: {
        orderNo: "",
        orderStatus: [],
        mainSearch: "",
        paymentStatus: ["Paid", "Unpaid", "Partial"],
        accountName: "",
        orderIdentity: "",
        account_id: "",
        contact_id: "",
        source: "cp",
        cp_user_id: "",
        customFilter:"",
    },
    statuses: [],
    paymentStatuses: ["Paid", "Unpaid", "Partial"],
    page: 0,
    count: 1,
    rowsPerPage: 50,
    orderConfirmations: {},
    artworkDocuments: {},
    invoiceDocuments: {},
    cleared: 0,
    currencyExchangeList: [],
    paymentData: paymentArray,
    metadata: {},

};

const OrdersReducer = (state: OrdersState = initState, action) => {
    switch (action.type) {
        case RECEIVE_ORDERS: {
            return {
                ...state,
                ordersList: action.payload,
                loading: false,
                fetchError: false,
                count: action.count,
                selectedOrderList: []
            }
        }
        case UPDATE_SELECTED_ORDERS: {
            return {
                ...state,
                selectedOrderList: action.payload,
            }
        }
        case RECEIVE_CURRENCY_EXCHANGE_RATES: {
            return {
                ...state,
                currencyExchangeList: action.payload,
            }
        }
        case UPDATE_PAYMENT_INFO: {
            return {
                ...state,
                paymentData: action.payload,
            }
        }
        case FETCH_ERROR: {
            return {
                ...state,
                fetchError: true,
                loading: false
            }
        }
        case RECEIVE_USER_LOGOUT: {
            return initState;
        }
        case IS_LOADING: return {
            ...state,
            loading: action.payload
        }
        case RECEIVE_STATUSES: return {
            ...state,
            fetchError: false,
            loading: false,
            statuses: action.payload
        }
        case UPDATE_FILTERS: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload
                }
            }
        }
        case RECEIVE_CURRENT_USER: {
            const currentUser: User = action.currentUser;
            if (currentUser.portalPermissions && currentUser.portalPermissions.Order[0].allowedOtherContacts) {
                return {
                    ...state,
                    statuses: currentUser.portalPermissions && currentUser.portalPermissions.Order[0].allowedStatus,
                    filters: {
                        ...state.filters,
                        cp_user_id: action.currentUser.contactId,
                        account_id: action.currentUser.accountId,
                        contact_id: !action.currentUser.portalPermissions.Order[0].allowedOtherContacts ? action.currentUser.contactId : '',
                        orderStatus: currentUser.portalPermissions && currentUser.portalPermissions.Order[0].allowedStatus,
                    },
                };
            } else {
                return {
                    ...state,
                    statuses: currentUser.portalPermissions.Order[0].allowedStatus,
                    filters: {
                        ...state.filters,
                        cp_user_id: action.currentUser.contactId,
                        account_id: action.currentUser.accountId,
                        orderStatus: currentUser.portalPermissions.Order[0].allowedStatus,
                        contact_id: !action.currentUser.portalPermissions.Order[0].allowedOtherContacts ? action.currentUser.contactId : '',
                    },
                };
            }
        }
        case RECEIVE_DOCUMENTS: {
            const document: IDocumentReference = action.document;
            let prop;
            switch (document.docType) {
                case "Invoice": {
                    prop = "invoiceDocuments";
                    break;
                }
                case "Order Confirmation": {
                    prop = "orderConfirmations";
                    break;
                }
                case "Art Proof": {
                    prop = "artworkDocuments";
                    break;
                }
            }
            if (prop) {
                if (prop === "orderConfirmations" && document.fileName.includes("Order_Confirmation")) {
                    return {
                        ...state,
                        [prop]: { ...state[prop], [document.refId]: document },
                    };
                }

                if (prop === "orderConfirmations" && !document.fileName.includes("Order_Confirmation")) {
                    return {
                        ...state
                    };
                }
                
                if (prop === "artworkDocuments") {
                    const existingDocuments = state[prop][document.refId] || [];
                    
                    const documentExists = existingDocuments.some(existingDoc => 
                        existingDoc.id === document.id && existingDoc.docType === document.docType
                    );
                    
                    if (documentExists) {
                        return {
                            ...state
                        };
                    }
                    
                    const updatedDocuments = [...existingDocuments, document];
                    return {
                        ...state,
                        [prop]: { ...state[prop], [document.refId]: updatedDocuments },
                    };
                }
                
                if (prop !== "orderConfirmations") {
                    return {
                        ...state,
                        [prop]: { ...state[prop], [document.refId]: document },
                    };
                } 
            } else {
                return {
                    ...state
                };
            }
        }
        case CLEAR_FILTERS: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    orderNo: "",
                    orderStatus: [...action.payload],
                    paymentStatus: ["Paid", "Unpaid", "Partial"],
                    accountName: "",
                    identity: "",
                    orderIdentity: "",
                    mainSearch: "",
                    source: "cp",
                },
                cleared: state.cleared + 1
            };
        }
        case RECEIVE_META_DATA:{
            return {
                ...state,
                metadata: action.payload
            }
        }
        default: return state;
    }
}

export default OrdersReducer;
